import { render, staticRenderFns } from "./loading-page.vue?vue&type=template&id=2e3acf90&scoped=true&lang=pug&"
import script from "./loading-page.vue?vue&type=script&lang=js&"
export * from "./loading-page.vue?vue&type=script&lang=js&"
import style0 from "./loading-page.vue?vue&type=style&index=0&id=2e3acf90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3acf90",
  null
  
)

export default component.exports